module.exports = __webpack_public_path__ + "img/ntv-64x64_old.f06f492e.png";